import React from "react";
import { FaCheckCircle, FaClock, FaHome, FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-5 text-center">
      {/* Icon */}
      <FaCheckCircle size={90} className="text-success mb-4 animate__animated animate__bounceIn" />

      {/* Heading */}
      <h1 className="display-5 fw-bold mb-2 animate__animated animate__fadeInDown">
        Thank You! 🎉
      </h1>

      {/* Subtitle */}
      <h2 className="h4 text-primary mb-3 animate__animated animate__fadeIn">
        Payment Received Successfully
      </h2>

      {/* Message */}
      <p className="lead text-muted mb-5 animate__animated animate__fadeInUp">
        Our team has received your request successfully.  
        We will get back to you within{" "}
        <span className="fw-bold text-dark">12 hours ⏳</span>.  
        Please keep your phone and email handy for updates.
      </p>

      {/* Info Card */}
      <div className="p-4 bg-light rounded-4 shadow-sm d-inline-block mb-5 animate__animated animate__zoomIn">
        <FaClock size={35} className="text-warning mb-2" />
        <h5 className="fw-bold mb-1">Expected Response Time</h5>
        <p className="mb-0 text-muted">Within 12 hours from now</p>
      </div>

      {/* Buttons */}
      <div className="d-flex flex-wrap gap-3 justify-content-center animate__animated animate__fadeInUp">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="btn btn-lg btn-gradient-primary d-inline-flex align-items-center gap-2"
        >
          <FaHome /> Back to Home
        </button>

       
      </div>

      {/* Quote */}
      <div className="mt-5 p-4 bg-info bg-opacity-10 rounded-4 shadow-sm animate__animated animate__fadeInUp">
        <p className="mb-0 fs-5 text-dark fst-italic">
          “Good things take time, and your patience means a lot to us.” ✨
        </p>
      </div>

      {/* Gradient Button CSS */}
      <style>{`
        .btn-gradient-primary {
          background: linear-gradient(90deg, #ff7a18 0%, #ff3d54 100%);
          color: #fff;
          border: none;
          box-shadow: 0 10px 20px rgba(255, 61, 84, 0.25);
        }
        .btn-gradient-primary:hover {
          filter: brightness(0.95);
          transform: translateY(-1px);
        }
      `}</style>
    </div>
  );
};

export default ThankYou;
